export default __webpack_public_path__ + "static/media/brand_id_8.11fb3eb4.jpg";